import { render, staticRenderFns } from "./TenancyCompanySelectorTest.vue?vue&type=template&id=63458628&scoped=true&"
import script from "./TenancyCompanySelectorTest.vue?vue&type=script&lang=js&"
export * from "./TenancyCompanySelectorTest.vue?vue&type=script&lang=js&"
import style0 from "./TenancyCompanySelectorTest.vue?vue&type=style&index=0&id=63458628&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63458628",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63458628')) {
      api.createRecord('63458628', component.options)
    } else {
      api.reload('63458628', component.options)
    }
    module.hot.accept("./TenancyCompanySelectorTest.vue?vue&type=template&id=63458628&scoped=true&", function () {
      api.rerender('63458628', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dev/TenancyCompanySelectorTest.vue"
export default component.exports